import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { CoinDto } from '../../models/coin-dto';
import { CoinService, CoinRow } from 'src/app/services/coin-service';
import { ApiService } from 'src/app/services/api.service';
import { RoutingService } from 'src/app/services/routing.service';
import { EntityType } from 'src/app/enums/entity-type.enum';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'coin',
  templateUrl: './coin.component.html',
  styleUrls: ['./coin.component.scss'],
})
export class CoinComponent implements OnInit, OnDestroy {
  private entityDetailsSubscription?: Subscription;
  closeClicked: Subject<void> = new Subject<void>();
  entityId: number = -1;
  coinLoading: boolean = false;
  coinDetails: CoinDto | null = null;
  rows: CoinRow[] = [];
  currentLanguage$!: Observable<string>;

  constructor(
    private routingService: RoutingService,
    private coinService: CoinService,
    private apiService: ApiService,
    private languageService: LanguageService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.currentLanguage$ = this.languageService.currentLanguage$;
    this.entityDetailsSubscription = this.routingService.entityDetails$.subscribe(entityDetails => {
      this.ngZone.run(() => {
        const { id, type } = entityDetails;
        if (!!id && type === EntityType.COIN) {
          this.entityId = id;
          this.getCoinDetails();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.entityDetailsSubscription?.unsubscribe();
  }

  getCoinDetails(): void {
    this.coinLoading = true;
    this.apiService
      .getCoinDetails(this.entityId)
      .pipe(takeUntil(this.closeClicked))
      .subscribe({
        next: (res: CoinDto) => {
          this.coinDetails = res;
          this.rows = this.coinService.getRows(res);
          this.coinLoading = false;
        },
        error: () => { this.coinLoading = false; },
        complete: () => { this.coinLoading = false; }
      });
  }
}
